import axios from 'axios';

export const GET_TRANSFERS = '/transfers/getTransfersByAgent';
export const SET_RECEIPT_LINES_HIDDEN = '/transfers/setReceiptLineHidden';
export const SET_RECEIPT_LINES_OWNERSHIP = '/transfers/setReceiptLineOwnership';
export const RESET_RECEIPT_LINES_OWNERSHIP = '/transfers/resetReceiptLineOwnership';
export const GET_TRANSFER = '/transfers/getTransfer';
export const CREATE_TRANSFER = '/transfers/createTransfer';
export const EDIT_TRANSFER = '/transfers/editTransfer';
export const DELETE_TRANSFER = '/transfers/deleteTransfer';
export const SPLIT_RECEIPT_LINES = '/transfers/splitReceiptLines';
export const UNSPLIT_RECEIPT_LINES = '/transfers/unsplitReceiptLine';
export const UPDATE_TAMAL = '/transfers/updateTamalID';
export const UPDATE_AVG_INCOME = '/transfers/updateAvgIncome';
export const UPDATE_ADMIN_NOTES = '/transfers/updateAdminNotes';
export const FIND_AGENTS = '/transfers/findAgents';

export function getTransfersByAgent(agentID) {
  return axios.post(GET_TRANSFERS, {agentID});
}

export function setReceiptLineHidden(receiptLineIDs, hidden) {
  return axios.post(SET_RECEIPT_LINES_HIDDEN, {receiptLineIDs, hidden});
}

export function setReceiptLineOwnership(receiptLineIDs, agentID) {
  return axios.post(SET_RECEIPT_LINES_OWNERSHIP, {receiptLineIDs, agentID});
}

export function resetReceiptLineOwnership(receiptLineIDs) {
  return axios.post(RESET_RECEIPT_LINES_OWNERSHIP, {receiptLineIDs});
}

export function getTransfer(transferID) {
  return axios.post(GET_TRANSFER, {transferID});
}

export function createTransfer(data) {
  return axios.post(CREATE_TRANSFER, data);
}

export function editTransfer(data) {
  return axios.post(EDIT_TRANSFER, data);
}

export function deleteTransfer(transferID) {
  return axios.post(DELETE_TRANSFER, {transferID});
}

export function splitReceiptLines(receiptLineId, amounts) {
  return axios.post(SPLIT_RECEIPT_LINES, {receiptLineId, amounts});
}

export function unsplitReceiptLine(receiptLineId) {
  return axios.post(UNSPLIT_RECEIPT_LINES, {receiptLineId});
}

export function updateTamal(data) {
  return axios.post(UPDATE_TAMAL, data);
}

export function updateAvgIncome(data) {
  return axios.post(UPDATE_AVG_INCOME, data);
}

export function updateAdminNotes(agentID, adminNotes) {
  return axios.post(UPDATE_ADMIN_NOTES, {agentID, adminNotes});
}

export function findAgents(text) {
  return axios.post(FIND_AGENTS, {text});
}